import React, { useEffect, useState } from "react";
import { Input } from "antd";
import Image from "../image/Image";
import { get_client_by_id } from "../../../api/endpoints/clients";
import { FaImages } from "react-icons/fa";
import { COLORS } from "../../layout/theme";
import { AntdTable, TitleContainer } from "./styles";
import AntdCheckbox from "../antd-checkbox/AntdCheckbox";

export default function DistributorLabAlerts({
	initialValues,
	onChange,
	clientId,
	flag,
}) {
	const [distributors, setDistributors] = useState(null);
	const [checkAllOutOfStock, setCheckAllOutOfStock] = useState(false);
	const [checkAllInexistent, setCheckAllInexistent] = useState(false);
	const [checkAllError, setCheckAllError] = useState(false);

	useEffect(() => {
		const fetch_distributors = async () => {
			const res = await get_client_by_id(clientId);
			setDistributors(
				initialValues
					? res.alerts
							.map((d) => ({
								key: d.id,
								...d,
							}))
							.map((d) => ({
								...d,
								alertEmail: initialValues?.find((i) => i.id === d.id)
									?.alertEmail,
								outOfStockItems: initialValues?.find((i) => i.id === d.id)
									?.outOfStockItems,
								inexistentItems: initialValues?.find((i) => i.id === d.id)
									?.inexistentItems,
								errorItems: initialValues?.find((i) => i.id === d.id)
									?.errorItems,
								// disabled: !!initialValues?.find((i) => i.id === d.id)?.code
								// 	? initialValues?.find((i) => i.id === d.id)?.code === "si" ||
								// 	  initialValues?.find((i) => i.id === d.id)?.code === ""
								// 		? false
								// 		: true
								// 	: false,
							}))
					: res.alerts.map((d) => ({
							key: d.id,
							...d,
					  }))
			);
		};
		if (clientId) fetch_distributors();
	}, [clientId, flag]);

	useEffect(() => {
		onChange(distributors);
	}, [distributors]);

	const handleChangeEmail = (text, record, index, value) => {
		let items = [...distributors];
		items[index] = {
			...distributors[index],
			alertEmail: value,
		};
		setDistributors(items);
	};

	const handleOutOfStockChange = (id, checked) => {
		const updatedDistributors = distributors.map((distributor) =>
			distributor.id === id
				? { ...distributor, outOfStockItems: checked }
				: distributor
		);
		setDistributors(updatedDistributors);
		setCheckAllOutOfStock(updatedDistributors.every((d) => d.outOfStockItems));
	};

	const handleInexistentChange = (id, checked) => {
		const updatedDistributors = distributors.map((distributor) =>
			distributor.id === id
				? { ...distributor, inexistentItems: checked }
				: distributor
		);
		setDistributors(updatedDistributors);
		setCheckAllInexistent(updatedDistributors.every((d) => d.inexistentItems));
	};

	const handleErrorChange = (id, checked) => {
		const updatedDistributors = distributors.map((distributor) =>
			distributor.id === id
				? { ...distributor, errorItems: checked }
				: distributor
		);
		setDistributors(updatedDistributors);
		setCheckAllError(updatedDistributors.every((d) => d.errorItems));
	};

	const handleSelectAll = (type, checked) => {
		const updatedDistributors = distributors.map((distributor) => {
			return { ...distributor, [type]: checked };
		});
		setDistributors(updatedDistributors);
	};

	const columns = [
		{
			title: (algo) => {
				return <FaImages style={{ color: COLORS.White }} />;
			},
			dataIndex: "photoUrl",
			key: "photoUrl",
			render: (data) => <Image width={40} height={40} src={data} />,
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Droguería</div>,
			dataIndex: "name",
			key: "name",
		},
		{
			title: () => (
				<TitleContainer>
					<div style={{ color: COLORS.White }}>Sin Stock</div>
					<AntdCheckbox
						checked={checkAllOutOfStock}
						indeterminate={
							distributors.some((d) => d.outOfStockItems) && !checkAllOutOfStock
						}
						onChange={(e) => {
							const checked = e.target.checked;
							setCheckAllOutOfStock(checked);
							handleSelectAll("outOfStockItems", checked);
						}}
					/>
				</TitleContainer>
			),
			dataIndex: "",
			render: (value, record, index) => (
				<AntdCheckbox
					onChange={(e) => handleOutOfStockChange(record.id, e.target.checked)}
					checked={record.outOfStockItems}
				/>
			),
		},
		{
			title: () => (
				<TitleContainer>
					<div style={{ color: COLORS.White }}>Inexistentes</div>
					<AntdCheckbox
						checked={checkAllInexistent}
						indeterminate={
							distributors.some((d) => d.inexistentItems) && !checkAllInexistent
						}
						onChange={(e) => {
							const checked = e.target.checked;
							setCheckAllInexistent(checked);
							handleSelectAll("inexistentItems", checked);
						}}
					/>
				</TitleContainer>
			),
			dataIndex: "",
			render: (value, record, index) => (
				<AntdCheckbox
					onChange={(e) => handleInexistentChange(record.id, e.target.checked)}
					checked={record.inexistentItems}
				/>
			),
		},
		{
			title: () => (
				<TitleContainer>
					<div style={{ color: COLORS.White }}>Con error</div>
					<AntdCheckbox
						checked={checkAllError}
						indeterminate={
							distributors.some((d) => d.errorItems) && !checkAllError
						}
						onChange={(e) => {
							const checked = e.target.checked;
							setCheckAllError(checked);
							handleSelectAll("errorItems", checked);
						}}
					/>
				</TitleContainer>
			),
			dataIndex: "",
			render: (value, record, index) => (
				<AntdCheckbox
					onChange={(e) => handleErrorChange(record.id, e.target.checked)}
					checked={record.errorItems}
				/>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Correo KAM</div>,
			dataIndex: "alertEmail",
			key: "alertEmail",
			render: (text, record, index) => (
				<Input
					value={record.alertEmail}
					onChange={(e) =>
						handleChangeEmail(text, record, index, e.target.value)
					}
					//disabled={record.disabled}
				/>
			),
		},
	];

	if (!distributors) return <div>Loading...</div>;

	return (
		<AntdTable
			size="small"
			columns={columns}
			dataSource={distributors}
			pagination={false}
		/>
	);
}
